<template>
  <div 
    v-if="!loading"
    class="hero-background-slider home__hero">
    <div
      v-swiper-heroes="swiperActiveIndex"
      class="swiper-container swiper-container--hero-background-slider" >
      
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div 
          v-for="(slide, index) of slidesArray"
          :key="index"
          class="swiper-slide">
          <HeroBackground :srcSetImages="slide.srcSetImages"/>
          <HeroTextSlider
            :heroH1="slide.heroH1"
            :heroH2="slide.heroH2"
            :heroP="slide.heroP"
            :heroLink="slide.heroLink"
            :heroLinkText="slide.heroLinkText"/>
        </div>
        <!-- Fine Slides -->
      </div>

      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>

    </div>
  </div>
  <div 
    v-else
    style="height:100vh; background-color: #FFF;">
    &nbsp;
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import swiper from './swiper'
import HeroBackground from '@/components/HeroBackground/HeroBackground.vue'
import HeroTextSlider from '@/components/HeroBackgroundSlider/HeroTextSlider/HeroTextSlider.vue'

export default {
  name: 'HeroBackgroundSlider',
  components: {
    HeroTextSlider,
    HeroBackground
  },
  mixins: [swiper],
  data: () => ({
    loading: true
  }),
  computed: {
    ...mapGetters('contentful', [
      'fullScreenGalleries'
    ]),
    ...mapGetters([
      'lang'
    ]),
    slidesArray: {
      get () {
        return this.fullScreenGalleries
          .filter(gallery => gallery.fields.whichPage === 'homepage')
          .reduce((accumulator, gallery) => {
            accumulator.push({
              srcSetImages: {
                '640': `${gallery.fields.imageSlide.fields.file.url}?w=640&fit=scale`,
                '1024': `${gallery.fields.imageSlide.fields.file.url}?w=1024&fit=scale`,
                '1440': `${gallery.fields.imageSlide.fields.file.url}?w=1440&fit=scale`,
                '1920': `${gallery.fields.imageSlide.fields.file.url}?w=1920&fit=scale`
              },
              heroH1: typeof gallery.fields.heroH1 !== 'undefined' ? gallery.fields.heroH1 : undefined,
              heroH2: typeof gallery.fields.heroH2 !== 'undefined' ? gallery.fields.heroH2 : undefined,
              heroP: typeof gallery.fields.heroP  !== 'undefined' ? gallery.fields.heroP : undefined,
              heroLink: typeof gallery.fields.heroLink !== 'undefined' ? this.$_createLinkUrl(gallery.fields.heroLink) : undefined,
              heroLinkText: typeof gallery.fields.heroLinkText !== 'undefined' ? gallery.fields.heroLinkText : undefined
            })
            return accumulator
          }, [])
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadFullScreenGalleries'
    ]),
    async loadData () {
      this.loading = true
      try {
        await this.loadFullScreenGalleries()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    },
    $_createLinkUrl (entry) {
      const contentTypeId = entry.sys.contentType.sys.id
      const map = {
        'it': {
          'products': 'prodotto',
          'category': 'assortimento',
          'posts': 'glaxi-academy'
        },
        'en': {
          'products': 'product',
          'category': 'assortment',
          'posts': 'glaxi-academy'
        }
      }
      return typeof map[this.lang][contentTypeId] === 'undefined' ? `/${this.lang}/${entry.fields.slug}/` : `/${this.lang}/${map[this.lang][contentTypeId]}/${entry.fields.slug}`
    }
  }
}

/*
slidesArrayCC: [
  {
    srcSetImages: {
      '640': require('@/assets/home/header-01-640.jpg'),
      '1024': require('@/assets/home/header-01-1024.jpg'),
      '1440': require('@/assets/home/header-01-1440.jpg'),
      '1920': require('@/assets/home/header-01-1920.jpg')
    },
    heroH1: 'Pane e prodotti da forno surgelati per la ristorazione',
    heroH2: "Il pane da trammezzino<br> per capolavori d'arte bianca.",
    heroP: 'Leggero, morbido, dal sapore delicato, il fondamento di ogni tramezzino gourmet.',
    heroLink: '',
    heroLinkText: 'Scopri il nostro pane per trammezzini'
  },
  {
    srcSetImages: {
      '640': require('@/assets/home/header-02-640.jpg'),
      '1024': require('@/assets/home/header-02-1024.jpg'),
      '1440': require('@/assets/home/header-02-1440.jpg'),
      '1920': require('@/assets/home/header-02-1920.jpg')
    },
    heroH1: 'Pane e prodotti da forno surgelati per la ristorazione',
    heroH2: "La genuinità del forno sotto casa,<br> la sicurezza della grande azienda.<br> Per un pane sempre fresco<br> e pronto all'uso",
    heroP: '',
    heroLink: '',
    heroLinkText: 'I vantaggi di sceglierci come partner'
  },
  {
    srcSetImages: {
      '640': require('@/assets/home/header-03-640.jpg'),
      '1024': require('@/assets/home/header-03-1024.jpg'),
      '1440': require('@/assets/home/header-03-1440.jpg'),
      '1920': require('@/assets/home/header-03-1920.jpg')
    },
    heroH1: 'Pane e prodotti da forno surgelati per la ristorazione',
    heroH2: "Trasformiamo la tua idea di pane<br> in un prodotto nuovo e unico.<br> Con la tua firma.",
    heroP: '',
    heroLink: '',
    heroLinkText: 'Crea il tuo pane'
  }
]*/
</script>

<style lang="scss">
  @import "./swiper.scss";
</style>